/**
 * SC Assessment Reducers
 */
 import {
    SCASSESSMENT_ACTION, 
    ALL_SCASSESSMENT,
    CHECK_SCASSESSMENT_DONE,
    ADD_SCASSESSMENT_SUCCESS,
    ADD_SCASSESSMENT_FAILURE,
    FETCH_SCASSESSMENT,
    EDIT_SCASSESSMENT_SUCCESS,
    EDIT_SCASSESSMENT_FAILURE,
    DELETE_SCASSESSMENT_SUCCESS,
    DELETE_SCASSESSMENT_FAILURE
 } from 'Actions/types';

/**
 * initial auth user
 */
const INIT_STATE = {
    strengthconditionlists:[],
    scresponse:[],
    loading: false,
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        
        case SCASSESSMENT_ACTION:
            return { ...state, loading: true };

        case ALL_SCASSESSMENT:
            return { ...state, loading: false, strengthconditionlists: action.payload };
        
        case CHECK_SCASSESSMENT_DONE:
            return { ...state, loading: false};
            
        case ADD_SCASSESSMENT_SUCCESS:
            return { ...state, loading: false };   
            
        case ADD_SCASSESSMENT_FAILURE:
            return { ...state, loading: false };    
        
        case FETCH_SCASSESSMENT:
            return { ...state, loading: false, scresponse:action.payload };    
            
        case EDIT_SCASSESSMENT_SUCCESS:
            return { ...state, loading: false};   
            
        case EDIT_SCASSESSMENT_FAILURE:
            return { ...state, loading: false};

        case DELETE_SCASSESSMENT_SUCCESS:
            return { ...state, loading: false};   
            
        case DELETE_SCASSESSMENT_FAILURE:
            return { ...state, loading: false};    

        default: return { ...state };
    }
}